import { ReactNode } from 'react';

interface EventViewSkeletonProps {
    sidebar?: ReactNode;
}

export function EventViewSkeleton({ sidebar }: EventViewSkeletonProps) {
    return (
        <div className="h-full relative overflow-hidden pt-14">
            <div className="h-full flex flex-col">
                <div className="flex-1 overflow-y-auto scrollbar-hide">
                    <div className="relative py-8">
                        <div className="max-w-content mx-auto">
                            <div className="flex flex-col gap-6 min-w-0">
                                <div className="w-full flex flex-col items-center">
                                    <div className="w-full aspect-video skeleton-item-container rounded-lg" />
                                    <div className="w-full mt-4 px-4">
                                        <div className="h-12 w-full skeleton-item-container rounded-md" />
                                    </div>
                                </div>

                                <div>
                                    <div className="h-[22px] w-[80px] skeleton-item-container rounded-[6px] mb-2" />
                                    <div className="h-[32px] w-[350px] skeleton-item-container rounded-md" />
                                </div>

                                <div className="h-[380px] w-full skeleton-item-container rounded-xl" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {sidebar}
        </div>
    );
}
